import gsap from "gsap";
import { DrawSVGPlugin, ScrollTrigger, ScrollSmoother } from "gsap/all";
import DefaultBlock from "/scripts/default/block";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

// Register Plugins
gsap.registerPlugin(ScrollTrigger);

export default class ScrollTriggerPin extends DefaultBlock {
	// Define variables
	init() {
		const selector = gsap.utils.selector(this.block);

		const DOM = {
			wrap: selector("#pin-windmill-wrap"),
			windmillWrap: selector("#pin-windmill-wrap"),
			windmill: selector("#pin-windmill"),
			windmillSvg: selector("#pin-windmill-svg"),
		};
		this.DOM = DOM;

		this.defaults = {
			ease: "power1.inOut",
			duration: 0.6,
		};

		this.tl = this.createTimeline();
	}

	createTimeline() {
		const tl = gsap.timeline({
			defaults: this.defaults,
			scrollTrigger: {
				scrub: 1,
				pin: true,
				trigger: this.DOM.windmill,
				start: "50% 50%",
				endTrigger: this.DOM.windmillWrap,
				end: "bottom 50%",
			},
		});

		tl.set(this.DOM.windmill, { autoAlpha: 1 });

		const mm = gsap.matchMedia();

		watchPreferredMotion(() => {
			/* Animate */
			tl.to(this.DOM.windmillSvg, {
				rotateZ: 900,
			});
		});

		return tl;
	}
}
